import React from "react";
import { Navigate } from "react-router-dom";

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
};

const PrivateRoute = ({ children }) => {
    const userToken = getCookie("user_token"); 
    const isAuthenticated = Boolean(userToken);

    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
